/**
 * 公共的ajax数据服务
 */
import axios from '../../common/ajax';

let service = {};
/**
 * 登录
 * @returns {*}
 */
service.login = (params) => {
	return axios.ajax('/login', 'get', params, 'form');
};

/**
* refresh token
* @returns {*}
*/
service.refershToken = (params) => {
	return axios.ajax('/authz/refershToken', 'post', params, 'form');
};

/**
 * 退出登录
 * @returns {*}
 */
service.logout = () => {
	return axios.ajax('/authz/logout', 'post', null);
};
// 获取左侧菜单树
service.getAuthTree = () => {
	return new Promise((resolve, reject) => {
		resolve([
			{
				'menuName': '小程序管理',
				'menuPath': '/icmp',
				'iconClass': 'icon-icon-projectmanagement',
				'menus': []
			},
			{
				'menuName': '公众号管理',
				'menuPath': '/icmp/official-account-manage',
				'iconClass': 'icon-icon-projectmanagement',
				'menus': []
			},
			{
				'menuName': '开放平台管理',
				'menuPath': '/icmp/open-platform-manage',
				'iconClass': 'icon-icon-projectmanagement',
				'menus': []
			},
			{
				'menuName': '客户管理',
				'menuPath': '/icmp/customer-manage',
				'iconClass': 'icon-icon-projectmanagement',
				'menus': []
			}
		]);
	});
};
export default service;



// WEBPACK FOOTER //
// ./main/service/login/index.js